export const SUPPLIER_ROLE_ID = 5
export const LIST_PAGE_SIZE = 50
export const IMPORT_STATUS_POLL_MS = 10000
export const IMPORT_IN_PROGRESS_STORAGE_KEY = 'importInProgress'
export const TOAST_MS = 5000
export const LOADING_TOAST_MS = 60000
export const SUPPORT_URL = 'https://support.zendrop.com'
export const IMPERSONATION_COOKIES = ['isAdminLoginAsUser', 'logged_in_admin_id', 'logged_in_admin_access_role_id']
